import { LinkFragment, StrategicLinkFragment } from '@go-shared/types/templateFragment';
import { apiPost } from '.';

export async function getDayGroupConflicts(
  propertyId: string,
  linkFragments: LinkFragment[]
): Promise<string[]> {
  return apiPost(`/property/${propertyId}/template-fragment/conflicts`, { linkFragments });
}

export async function linkTemplateFragments(
  propertyId: string,
  linkFragments: LinkFragment[]
): Promise<boolean> {
  return apiPost(`/property/${propertyId}/template-fragment/link`, { linkFragments });
}

export async function unlinkTemplateFragments(
  propertyId: string,
  linkFragments: StrategicLinkFragment[]
): Promise<boolean> {
  return apiPost(`/property/${propertyId}/template-fragment/unlink`, { linkFragments });
}
